<script lang="ts">
	import TemplateCategory from '$lib/templates/TemplateCategory.svelte';
  import { page } from '$app/stores';
</script>


{#key $page.params.cat_url}
  <TemplateCategory category={$page.data.category} />
{/key}

